<template>
  <div>
    <div class="paragraph-delimiter"></div>

    <div class="h4">Дитячим видавництвам</div>
    <p>
      Radiokids.online радо підтримує розвиток української та перекладної
      дитячої літератури. Тож якщо ви зацікавлені у просуванні вашої продукції,
      ми радо озвучимо фрагменти з них, анонсуємо появу нових видань,
      запишемо передачі з вашими авторами.
    </p>

    <div class="paragraph-delimiter"></div>

    <div class="h4">Театрам, музеям, виставковим центрам і приватним ініціативам</div>
    <p>
      Ми раді співпраці з культурними інституціями, які пропонують програми
      для малят 0+ та дошкільнят. Надсилайте нам анонси дитячих заходів та
      свої пропозиції щодо співпраці
      <a
        href="mailto:radiokids.online@gmail.com?subject=Співпраця з культурними інституціями"
        v-b-popover.hover.top="'radiokids.online@gmail.com'"
      >
        сюди
      </a>.
    </p>

    <div class="paragraph-delimiter"></div>

    <div class="h4">Авторам дитячої літератури</div>
    <p>
      Ви пишете дитячі пісні, вірші або казки і хочете, щоб вони прозвучали в
      ефірі нашого радіо? Надсилайте тексти на нашу
      <a
        href="mailto:radiokids.online@gmail.com?subject=Дитяча література"
        v-b-popover.hover.top="'radiokids.online@gmail.com'"
      >
        поштову скриньку
      </a>.
      Найкращі роботи обов’язково потраплять в ефір!
    </p>

    <div class="paragraph-delimiter"></div>

    <div class="h4">Волонтерам та студентам</div>
    <p>
      Ти талановитий журналіст, звукорежисер, контент-менеджер, ведучий
      радіопередач, редактор передач, тоді надсилай нам своє резюме і
      мотиваційний лист на
      <a
        href="mailto:radiokids.online@gmail.com?subject=Волонтер"
        v-b-popover.hover.top="'radiokids.online@gmail.com'"
      >
        поштову скриньку
      </a>.
      Прохання вказати тему листа «волонтер».
      Найкращі з вас отримають цікавий новий досвід і розкриття свого
      творчого потенціалу! Долучайся до нашої команди.
    </p>

    <div class="paragraph-delimiter"></div>
  </div>
</template>

<script>
export default {
  name: 'CooperationPage'
}
</script>

<style lang="scss" scoped>
  @import "../../common.scss";
</style>



// WEBPACK FOOTER //
// src/components/Pages/CooperationPage.vue